import React from 'react';
import { Card, Typography, Tag } from 'antd';
import { AppListItem } from '../../types';
import './AppCard.css';

const { Title } = Typography;

interface AppCardProps {
  app: AppListItem;
  showClickCount?: boolean;
  isNew?: boolean;
  isHot?: boolean;
}

const AppCard: React.FC<AppCardProps> = ({
  app,
  showClickCount = false,
  isNew = false,
  isHot = false
}) => {
  return (
    <a href={`/app/${app.id}`} className="app-card-link">
      <Card
        className="app-card game-card-hover"
        hoverable={false}
        bodyStyle={{ padding: 0 }}
        bordered={false}
      >
        <div className="app-card-content">
          {/* 游戏图片区域 */}
          <div className="app-image-section">
            <img
              src={app.icon_url}
              alt={app.name}
              className="app-image"
            />
            {/* 标签 */}
            {(isNew || isHot) && (
              <div className="app-tags">
                {isNew && <Tag className="tag-new">New</Tag>}
                {isHot && <Tag className="tag-hot">Hot</Tag>}
              </div>
            )}
          </div>

          {/* 游戏信息区域 */}
          <div className="app-info-section">
            <Title level={5} className="app-title" ellipsis={{ rows: 1 }}>
              {app.name}
            </Title>

            {/* 分类信息 */}
            {app.category && (
              <div className="app-category">
                <span className="category-name">{app.category.name}</span>
              </div>
            )}

            {/* 点击次数（如果启用） */}
            {showClickCount && app.click_count !== undefined && (
              <div className="app-click-count">
                <span className="click-count-text">Views: {app.click_count}</span>
              </div>
            )}
          </div>
        </div>
      </Card>
    </a>
  );
};

export default AppCard;
